import { NextIntlClientProvider, useLocale, useMessages } from 'next-intl';
import { FC, PropsWithChildren } from 'react';

type NextIntlProviderProps = PropsWithChildren<{
  keys: string[];
}>;

export const TranslationsProvider: FC<NextIntlProviderProps> = ({
  children,
  keys
}) => {
  const locale = useLocale();
  const messages = useMessages() ?? {};
  const filteredKeys = keys.filter((key) => !!messages[key]);

  const filteredEntries = filteredKeys.map((key) => [key, messages[key]]);
  const filteredMessages = Object.fromEntries(filteredEntries);

  return (
    <NextIntlClientProvider locale={locale} messages={filteredMessages}>
      {children}
    </NextIntlClientProvider>
  );
};
